import { Radio } from 'informed';
import PropTypes from 'prop-types';

import { Card, CardContent } from 'Cards';

import '../styles/cardSelectStyles.css';

const BASE_CLASSES =
  'card-option flex flex-col relative rounded focus-within:outline-none focus-within:shadow-focus';

const CardSelectRadio = ({
  children,
  disabled,
  fieldValue,
  id,
  value,
  ...rest
}) => {
  const isSelected = fieldValue === value;
  return (
    <label
      className={[
        BASE_CLASSES,
        disabled ? 'disabled cursor-not-allowed' : 'hover:shadow-dropdown',
        isSelected ? 'selected' : '',
      ].join(' ')}
      htmlFor={id}
    >
      <Card>
        <Radio
          className="absolute top-0 left-0 opacity-0"
          disabled={disabled}
          id={id}
          value={value}
          {...rest}
        />
        <CardContent>{children}</CardContent>
      </Card>
    </label>
  );
};

CardSelectRadio.defaultProps = {
  disabled: false,
  fieldValue: undefined,
};

CardSelectRadio.propTypes = {
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  fieldValue: PropTypes.string,
  id: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
};

export default CardSelectRadio;
